import "./Legal.module.css";
import Header from "@/reusable_sections/Header";
import Legal from "./sections/Legal";
import Accompaniment from "./sections/Accompaniment";
import Action from "./sections/Action";
import Footer from "@/reusable_sections/Footer";
export default function LegalPage() {
  return <div>
      <Header />
      <Legal />
      <Accompaniment />
      <Action />
      <Footer />
    </div>;
}